import type {Job,MediaAsset} from '../types';
export function mergeLocalOutputs(jobs:Job[],media:MediaAsset[],userId=''):Job[]{
  const all=[...jobs];
  for(const item of media){
    if(!item.stored_on_device||!item.generation_job_id||all.some(job=>job.id===item.generation_job_id))continue;
    const snapshot=item.generation_job;
    if(!snapshot&&!item.model_id)continue;
    all.push({...snapshot,id:item.generation_job_id,user_id:snapshot?.user_id||userId,status:'completed',generation_kind:item.kind.includes('audio')?'audio':'image',model_id:snapshot?.model_id||item.model_id!,prompt:snapshot?.prompt||item.prompt||'',aspect_ratio:snapshot?.aspect_ratio||'auto',duration_seconds:snapshot?.duration_seconds??null,created_at:snapshot?.created_at||item.created_at,outputs:[]});
  }
  return all.map(job=>{
    if((job.generation_kind??'video')==='video')return job;
    const local=media.filter(item=>item.stored_on_device&&item.generation_job_id===job.id);
    if(!local.length)return job;
    const outputs=[...(job.outputs??[])];
    for(const item of local){if(outputs.some(output=>output.media_id===item.id))continue;outputs.push({generation_job_id:job.id,media_id:item.id,position:outputs.length,kind:item.kind,...(item.original_name?{original_name:item.original_name}:{}),mime_type:item.mime_type,byte_size:item.byte_size,created_at:item.created_at})}
    return {...job,outputs};
  }).sort((a,b)=>b.created_at.localeCompare(a.created_at));
}
